import FormattedMessage from 'I18n/components/FormattedMessage';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { Flex } from 'foundations-components/components/Flex';
import { Illustration } from 'foundations-components/transitional/components/Illustration';
import { RefreshIcon } from 'foundations-assets/icons/components/RefreshIcon';
import { CreditCardIcon } from 'foundations-assets/icons/components/CreditCardIcon';
import RouterTabs from 'ui-addon-react-router-dom/RouterTabs';
import RouterTab from 'ui-addon-react-router-dom/RouterTab';
import { useQuery } from 'data-fetching-client';
import { ROUTES } from '../components/Routes';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import useBillingAndPaymentsData from '../hooks/useBillingAndPaymentsData';
import { useIsMobileView } from '../hooks/useWindowSize';
import { GET_SETTINGS } from '../queries';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export function TabContainer({
  children
}) {
  var _settingsData$setting;
  const {
    loading,
    data: {
      paymentMethods,
      subscriptions,
      invoices
    }
  } = useBillingAndPaymentsData();
  const {
    data: settingsData
  } = useQuery(GET_SETTINGS);
  const pageTitle = settingsData === null || settingsData === void 0 || (_settingsData$setting = settingsData.settings) === null || _settingsData$setting === void 0 ? void 0 : _settingsData$setting.pageTitle;
  const hasNoPaymentMethods = (paymentMethods === null || paymentMethods === void 0 ? void 0 : paymentMethods.length) === 0;
  const hasNoData = (subscriptions === null || subscriptions === void 0 ? void 0 : subscriptions.length) === 0 && (invoices === null || invoices === void 0 ? void 0 : invoices.length) === 0 && (paymentMethods === null || paymentMethods === void 0 ? void 0 : paymentMethods.length) === 0;
  const isMobileView = useIsMobileView();
  return /*#__PURE__*/_jsxs(View, {
    paddingInline: isMobileView ? '500' : '1400',
    paddingBlock: "700",
    children: [/*#__PURE__*/_jsx(Text, {
      as: "h1",
      typography: "heading-600",
      paddingBlockStart: "500",
      paddingBlockEnd: "200",
      marginBlockEnd: "700",
      children: pageTitle
    }), loading ? /*#__PURE__*/_jsx(Flex, {
      justifyContent: "center",
      alignItems: "center",
      marginBlockStart: "1500",
      children: /*#__PURE__*/_jsx(LoadingSpinner, {})
    }) : hasNoData ? /*#__PURE__*/_jsxs(Flex, {
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      marginBlockStart: "1500",
      children: [/*#__PURE__*/_jsx(View, {
        blockSize: "250px",
        marginBlockEnd: "700",
        children: /*#__PURE__*/_jsx(Illustration, {
          name: "empty-state-charts",
          width: 250
        })
      }), /*#__PURE__*/_jsx(Text, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "app.emptyState.title"
        })
      }), /*#__PURE__*/_jsx(Text, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "app.emptyState.subtitle"
        })
      })]
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(View, {
        inlineSize: "fit-content",
        marginBlockEnd: "1100",
        children: /*#__PURE__*/_jsxs(RouterTabs, {
          children: [/*#__PURE__*/_jsx(RouterTab, {
            title: /*#__PURE__*/_jsxs(Flex, {
              alignItems: "center",
              gap: "200",
              children: [/*#__PURE__*/_jsx(RefreshIcon, {}), /*#__PURE__*/_jsx(FormattedMessage, {
                message: "app.billing"
              })]
            }),
            to: ROUTES.billing,
            exact: true,
            disabled: loading
          }), /*#__PURE__*/_jsx(RouterTab, {
            tooltip: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "paymentMethods.empty"
            }),
            tooltipPlacement: "right",
            tooltipProps: {
              disabled: !hasNoPaymentMethods
            },
            title: /*#__PURE__*/_jsxs(Flex, {
              alignItems: "center",
              gap: "200",
              children: [/*#__PURE__*/_jsx(CreditCardIcon, {}), /*#__PURE__*/_jsx(FormattedMessage, {
                message: "app.payments"
              })]
            }),
            to: ROUTES.payments,
            exact: true,
            disabled: loading || hasNoPaymentMethods
          })]
        })
      }), children]
    })]
  });
}